import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FooterLogo from "./FooterLogo";

export default function ConfirmationPage() {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setAccepted(e.target.checked);
    if (e.target.checked) {
      navigate("/form2");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 py-10 px-4 ">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full sm:w-2/3 md:w-1/2">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="Logo" className="w-81 h-auto" />
        </div>
        <p className="text-gray-700 mb-6 space-y-2">
          <strong>Your appointment with Dr H.J. Pretorius has been confirmed.</strong><br />
          Please read and familiarize yourself with the billing information provided below. Take a moment to review everything carefully and confirm your acceptance.
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 text-sm">
          <li>Kindly note that this practice charges private rates and depending on your choice of medical scheme, co-payments will be applicable to all forms of service delivery. (Discovery Classic, Discovery Executive and Bestmed options are excluded from this due to a contractual agreement).</li>
          <li>First consultations are charged at R 1700.00. This fee is payable immediately.</li>
          <li>All follow up consultations are charged in line with your nominated medical scheme and payment thereof is subject to the availability of funds. Private patients this will be charged R550.00 per follow-up visit.</li>
          <li>Hospital procedures are charged at Discovery Classic rates of 217%.</li>
          <li>Should your procedure not be classified or approved as a PMB (Prescribed Minimum Benefits) claim, there will be a co-payment for your procedure.</li>
          <li>Authorizations for hospital procedures are not a guarantee of payment and it remains the responsibility of the guarantor/patient to ensure compliance.</li>
          <li>In the event that your medical scheme rejects any procedure code, or does not cover the amount in full, the guarantor remains responsible for the full settlement thereof.</li>
          <li>It remains the responsibility of the guarantor/patient to ensure that all outstanding accounts are settled in full within 60 days of service delivery.</li>
          <li>This practice reserves the right to charge interest of prime + 2% on outstanding accounts which are older than 60 days.</li>
          <li>Please inform this practice in writing of any changes in contact details.</li>
          <li>By submitting this form, you consent to the collection and use of your personal information in accordance with the Protection of Personal Information Act (POPIA).</li>
        </ul>
        <div className="mt-6">
          <label className="flex items-center text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              checked={accepted}
              onChange={handleCheckboxChange}
              className="w-10 h-10 mr-2"
            />
            Confirm your acceptance
          </label>
        </div>
      </div>
      <FooterLogo />
    </div>
  );
}
